const getRandomSeed = () => Math.floor(Math.random() * 1000000000 + 1);

export default getRandomSeed;
